import { createRouter, createWebHistory } from 'vue-router'
import { loginGuard } from '@shared/router/loginGuard'
import { warehouseRoutes } from '../../../shared/src/warehouse/routes'
import { assetManagementRoutes } from '@shared/assetManagement/routes'
import { twinModellingRoutes } from '@shared/twinModelling/routes'
import { userManagementRoutes } from '@shared/userManagement/router'
import { ticketManagementRoutes } from '@shared/maintenance/routes'
import { baseRoutes } from '@shared/baseRoutes'
import { clearBreadCrumbs } from '@shared/util/breadCrumbs'
import { qmdRoutes } from '@shared/qualityManagementDocuments/routes'
import { itAssetManagementRoutes } from '@shared/itAssetManagement/routes'
import { businessPartnersRoutes } from '@shared/businesspartners/routes'
import { onRouteError } from '@shared/router/onRouteError'
import { i18n } from '@demo/main'
import { knowledgeSpacesRoutes } from '@shared/knowledgeSpaces/routes'
import { processMiningRoutes } from '@shared/processMining/routes'
import { shopFloorWalkRoutes } from '@shared/shopFloorWalk/routes'
import { productsRoutes } from '@shared/products/routes.ts'
import { productComplianceRoutes } from '@shared/productCompliance/routes'

const routes = [
  ...baseRoutes,
  ...warehouseRoutes,
  ...shopFloorWalkRoutes,
  // Override the shared asset management detail view with the demo-specific one
  // that injects OEE and dashboard tabs via customTabs
  {
    path: '/asset-management/:template/edit/:id?',
    name: 'assetManagementDetail',
    props: true,
    component: () => import('../assetManagement/DemoAssetManagementDetailView.vue'),
    meta: {
      appClientId: 'smx-portal',
      breadcrumbs: [
        {
          label: 'assets',
          route: { name: 'assetManagement' }
        }
      ]
    }
  },
  ...assetManagementRoutes.filter((r) => r.name !== 'assetManagementDetail'),
  ...twinModellingRoutes,
  ...userManagementRoutes,
  ...ticketManagementRoutes,
  ...qmdRoutes,
  ...itAssetManagementRoutes,
  ...businessPartnersRoutes,
  ...knowledgeSpacesRoutes,
  ...processMiningRoutes,
  ...productsRoutes,
  ...productComplianceRoutes,

  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/login/openId-callback',
    name: 'loginOpenIdCallback',
    component: () => import('../views/LoginOpenIdCallback.vue')
  },

  {
    path: '/apps-admin/',
    name: 'appsAdmin',
    component: () => import('@shared/components/apps/AppsSettings.vue'),
    meta: {
      appClientId: 'smx-portal-mgmt',
      breadcrumbs: [
        {
          label: 'appsAdmin',
          route: { name: 'appsAdmin' }
        }
      ]
    }
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach(loginGuard)
router.beforeEach(clearBreadCrumbs)

router.onError((error, to) => onRouteError(error, to, i18n))

export default router
